import { resolveHTTP } from '@/services/api'

const Api = resolveHTTP('/bl/jurisprudence-files')

Api.storeByFileRoute = () => {
  return Api.apiURl + Api.relativeUrl + '/store-by-file'
}

export default Api



// WEBPACK FOOTER //
// ./src/services/api/bl-jurisprudencefiles.js